<template>
  <v-container fluid class="pa-4 fill-height align-start">

    <div style="position: absolute; left: -9999px; top: -9999px;">
        <impressao-pedido ref="geradorPdf" :modo-componente="true" />
    </div>
    
    <v-overlay :value="loading" opacity="0.8" z-index="9999">
      <div class="d-flex flex-column align-center justify-center">
        <v-progress-circular indeterminate size="64" color="primary"></v-progress-circular>
        <div class="white--text mt-3 font-weight-bold text-center">
          {{ statusMensagem }}
        </div>
      </div>
    </v-overlay>

    <v-row justify="center" class="mb-4">
      <v-col cols="12" md="8" lg="6">
        <v-card class="report-card rounded-xl d-flex flex-column align-center text-center transition-swing h-100"
                hover @click="enviarCarga" :disabled="loading">
          <v-card-text class="d-flex flex-column justify-center align-center pa-6">
            <v-icon size="64" color="primary" class="mb-4">mdi-cloud-download-outline</v-icon>
            <h3 class="text-h6 font-weight-regular">Importação</h3>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-row justify="center" class="mb-4">
      <v-col cols="12" md="8" lg="6">
        <v-card class="report-card rounded-xl d-flex flex-column align-center text-center transition-swing h-100"
                hover @click="enviarTransmissao" :disabled="loading">
          <v-card-text class="d-flex flex-column justify-center align-center pa-6">
            <v-icon size="64" color="primary" class="mb-4">mdi-cloud-upload-outline</v-icon>
            <h3 class="text-h6 font-weight-regular">Exportação</h3>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-row justify="center">
      <v-col cols="12" md="8" lg="6">
        <v-card class="report-card rounded-xl d-flex flex-column align-center text-center transition-swing h-100"
                hover @click="enviarLimpeza" :disabled="loading">
          <v-card-text class="d-flex flex-column justify-center align-center pa-6">
            <v-icon size="64" color="grey darken-1" class="mb-4">mdi-broom</v-icon>
            <h3 class="text-h6 font-weight-regular">Limpeza</h3>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    
    <v-dialog v-model="limpezaDialog" max-width="450">
      <v-card>
        <v-card-title class="headline primary white--text">
          Confirmação de Limpeza
        </v-card-title>
        <v-card-text class="pt-4 pb-0 text-body-1 black--text">
          <p>Deseja apagar todos os pedidos e visitas <b>já enviados (Atendidos)</b>?</p>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="black" text @click="limpezaDialog = false">Cancelar</v-btn>
          <v-btn color="white" class="primary" text @click="confirmarLimpeza">Confirmar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogSemConexao" max-width="450">
      <v-card>
        <v-card-title class="headline primary white--text">Sem Conexão</v-card-title>
        <v-card-text class="pt-4 pb-0 text-body-1 black--text">O aparelho não está conectado à Internet. Verifique sua conexão e tente novamente.</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="dialogSemConexao = false">OK</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogUrl" max-width="450">
      <v-card>
        <v-card-title class="headline primary white--text">Configuração Incompleta</v-card-title>
        <v-card-text class="pt-4 pb-0 text-body-1 black--text">A URL do servidor não está configurada. Realize uma Carga de dados primeiro.</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="white" class="primary" text @click="dialogUrl = false">OK</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    

    <v-dialog v-model="dialogResultado.show" max-width="450">
      <v-card>
        <v-card-title :class="`headline ${dialogResultado.color} white--text`">
          <v-icon left dark>{{ dialogResultado.icon }}</v-icon>
          {{ dialogResultado.title }}
        </v-card-title>
        <v-card-text class="pt-4 pb-0 text-body-1 black--text" v-html="dialogResultado.message"></v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="dialogResultado.show = false">OK</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </v-container>
</template>

<script>
import db from '@/plugins/dexie';
import ImpressaoPedido from '@/views/pedido/impressaopedido/Index.vue';
import { VENDEDOR_STORAGE } from '@/constants/STORAGE';

export default {
  name: 'ViewSincronizar',
  components: { ImpressaoPedido },
  data() {
    return {
      idVendedor: 0,
      nomeVendedor: '',
      idEmpresa: 0,
      senha: '',
      baseUrl: '',
      loading: false,
      statusMensagem: 'Processando...',
      limpezaDialog: false,
      dialogSemConexao: false,
      dialogUrl: false,
      dialogConfirmar: false,
      urlApiNodeEmail: 'https://oagrobrasil.com.br/apiemail',
      dialogResultado: {
        show: false,
        title: '',
        message: '',
        icon: '',
        color: ''
      },
    };
  },
  
  async mounted() {
    await this.carregarConfiguracoes();
  },

  methods: {

    formatarDataSQL(data) {
      if (!data) return null;
      const pad = (n) => (n < 10 ? '0' + n : n);
      return (
        data.getFullYear() + '-' +
        pad(data.getMonth() + 1) + '-' +
        pad(data.getDate()) + ' ' +
        pad(data.getHours()) + ':' +
        pad(data.getMinutes()) + ':' +
        pad(data.getSeconds())
      );
    },

    async carregarConfiguracoes() {
      try {
        const params = await db.parametro.toArray();
        
        if (params.length > 0) {
          const param = params[params.length - 1];
          this.idEmpresa = param.empresa ? parseInt(param.empresa) : 1;
          const urlDoBanco = param.linkwebservice; 

          if (urlDoBanco && typeof urlDoBanco === 'string' && urlDoBanco.trim().length > 0) {
            this.baseUrl = urlDoBanco.trim();
            if (!this.baseUrl.endsWith('/')) {
              this.baseUrl += '/';
            }
          }
        }

        const userIdStorage = sessionStorage.getItem(VENDEDOR_STORAGE.venidnuvem);

        if (userIdStorage && userIdStorage !== 'null' && userIdStorage !== 'undefined') {
          
          let user = null;
          const idParseado = parseInt(userIdStorage);

          if (!isNaN(idParseado)) {
            user = await db.vendedor.where('idvendedor').equals(idParseado).first();
          }

          if (!user) {
            user = await db.vendedor.where('idvendedor').equals(userIdStorage).first();
          }
          if (user) {
            this.idVendedor = parseInt(user.venidnuvem) || parseInt(user.codigo) || parseInt(user.idvendedor) || 0;
            this.senha = user.vensenha || user.senha || ''; 
            this.nomeVendedor = user.vennome || user.nome || '';
          }
        }

      } catch (err) {
        console.error("Erro ao carregar configurações (carregarConfiguracoes):", err);
      }
    },
    
    async fetchWcf(metodo, dataToSend, verboHttp = 'POST') {
      if (!this.baseUrl) {
        await this.carregarConfiguracoes();
        if (!this.baseUrl) throw new Error("URL do servidor não configurada.");
      }

      const url = `${this.baseUrl}${metodo}?ChaveSistema=m1cr0s3rv`;
      
      const headers = { 
        'Content-Type': 'application/json' 
      };

      try {
        const registroEmpresa = await db.empresa.limit(1).first();
        if (registroEmpresa && registroEmpresa.EMPChaveAppVenda) {
          headers['Authorization'] = registroEmpresa.EMPChaveAppVenda;
        }
      } catch (err) {
        console.warn("Não foi possível carregar a chave da empresa para o header:", err);
      }

      try {
        const response = await fetch(url, {
          method: verboHttp,
          headers: headers,
          body: JSON.stringify(dataToSend),
        });

        if (!response.ok) {
          if (response.status === 401) throw new Error("Transmissão recusada: Chave da Empresa Inválida (401).");
          if (response.status === 404) throw new Error(`Rota não encontrada no servidor: ${metodo}`);
          if (response.status === 500) throw new Error("Erro interno no Servidor (500).");
          throw new Error(`Erro HTTP ${response.status}`);
        }

        return await response.json();

      } catch (error) {
        if (error.message.includes('Failed to fetch') || error.message.includes('NetworkError')) {
          throw new Error("Falha de Conexão. Verifique se o servidor está ligado e acessível.");
        }
        throw error;
      }
    },

    enviarCarga() {
      this.$router.push('/carga_total');
    },

    async enviarTransmissao() {
      this.$router.push('/sincronizar_enviar');
    },


    enviarLimpeza() {
      this.limpezaDialog = true;
    },
    
    async confirmarLimpeza() {
      this.limpezaDialog = false;
      this.loading = true;
      this.statusMensagem = "Atualizando dados (Limpeza)...";

      try {
        const dataAtual = this.formatarDataSQL(new Date());

        const pedidosEnviados = await db.pedido
          .where('atendido').equals(1)
          .filter(p => !p.datalimpeza && parseInt(p.orcamento) !== 1) 
          .toArray();

        let totalItensAtualizados = 0;

        if (pedidosEnviados.length > 0) {
          const idsVinculoSet = new Set();

          pedidosEnviados.forEach(p => {
            if (p.idpedido) {
              idsVinculoSet.add(p.idpedido);
              idsVinculoSet.add(parseInt(p.idpedido));
              idsVinculoSet.add(String(p.idpedido));
            }
          });

          const arrayIdsParaAtualizar = Array.from(idsVinculoSet);

          if (arrayIdsParaAtualizar.length > 0) {
            totalItensAtualizados = await db.pedidoitem
              .where('idpedido')
              .anyOf(arrayIdsParaAtualizar)
              .filter(item => !item.datalimpeza)
              .modify({ datalimpeza: dataAtual });
          }

          await db.pedido
            .where('atendido').equals(1)
            .filter(p => !p.datalimpeza && parseInt(p.orcamento) !== 1)
            .modify({ 
              datalimpeza: dataAtual, 
              pedidolimpo: 1
            });
        }

        const totalVisitasAtualizadas = await db.visita
          .where('atendido').equals(1)
          .filter(v => !v.datalimpeza)
          .modify({ datalimpeza: dataAtual });

        let msgDetalhes = `Foram marcados como limpos ${pedidosEnviados.length} pedidos e ${totalVisitasAtualizadas} visitas.`;
        
        if (totalItensAtualizados > 0) {
          msgDetalhes += `<br><small>(Total de itens de pedido atualizados: ${totalItensAtualizados})</small>`;
        } else if (pedidosEnviados.length === 0 && totalVisitasAtualizadas === 0) {
          msgDetalhes = "Não há novos registros enviados para serem limpos no momento.";
        }

        this.dialogResultado = {
          show: true,
          title: 'Limpeza Concluída',
          message: msgDetalhes,
          icon: 'mdi-check-circle-outline',
          color: 'primary'
        };

      } catch (e) {
        console.error("Erro na limpeza:", e);
        this.dialogResultado = {
          show: true,
          title: 'Erro',
          message: 'Não foi possível atualizar a data de limpeza no banco de dados.',
          icon: 'mdi-alert-circle',
          color: 'error'
        };
      } finally {
        this.loading = false;
      }
    }
  },
};
</script>

<style scoped>
.bg-light { background-color: #f8fafc; }

.color-dark { color: #1e293b; }
.color-muted { color: #64748b; }

.max-w-custom {
  max-width: 900px;
}

.report-card {
  cursor: pointer;
  border: 1px solid rgba(0,0,0,0.03) !important;
  background-color: #ffffff;
}

.report-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 12px 20px -8px rgba(0, 0, 0, 0.12) !important;
  border-color: rgba(0,0,0,0.08) !important;
}

.h-100 {
  height: 100%;
}
</style>